import { render, staticRenderFns } from "./allMailingListsViewTable.vue?vue&type=template&id=65fbe188"
import script from "./allMailingListsViewTable.vue?vue&type=script&lang=js"
export * from "./allMailingListsViewTable.vue?vue&type=script&lang=js"
import style0 from "./allMailingListsViewTable.vue?vue&type=style&index=0&id=65fbe188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports